/* eslint-disable */
// ** React Imports
import { Link } from 'react-router-dom';
// ** Reactstrap Imports
import {
  ReactstrapDropdownItem as DropdownItem,
  ReactstrapDropdownMenu as DropdownMenu,
  ReactstrapDropdownToggle as DropdownToggle,
  ReactstrapUncontrolledDropdown as UncontrolledDropdown
} from '@febos-io/design';

// ** Third Party Components

// ** Custom Components
import Avatar from '../../../components/avatar';
// ** Default Avatar Image
import defaultAvatar from '../../../../assets/images/portrait/small/avatar-s-11.jpg';
import Icon from '../../../../../components/Icon';

export function UserDropdown() {
  return (
    <UncontrolledDropdown
      tag="li"
      className="dropdown-user nav-item"
    >
      <DropdownToggle
        href="/"
        className="nav-link dropdown-user-link"
        tag="a"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name fw-bold">John Doe</span>
          <span className="user-status">Admin</span>
        </div>
        <Avatar
          img={defaultAvatar}
          imgHeight="40"
          imgWidth="40"
          status="online"/>
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem
          tag={Link}
          to="/sign-in"
        >
          <Icon
            icon="fa-sign-out"
            className="me-75"
          />
          <span className="align-middle">Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

export default UserDropdown;
